let contentBlock = document.querySelector('.single-blog-content-body, .author__description');

export default function () {
  let row = document.querySelector('.single-blog-content__inner, .author__inner');

  if (!contentBlock || !row) return;

  if (contentBlock) {
    const visibleArea = 200;
    const distanceToScroll = 100;
    const sidebar = document.createElement('div');
    const makerForTable = contentBlock.querySelectorAll('h2');
    const tableBlock = document.createElement('ul');
    const staticPositionOfWindow = window.pageYOffset;

    let coordsArr = [];

    sidebar.classList.add('sidebar');
    tableBlock.classList.add('content-table');

    makerForTable.forEach((el, index) => {
      el.setAttribute('data-marker', `${index}`);
      const createElement = document.createElement('li');
      createElement.classList.add(`content-table__item`);
      createElement.setAttribute('data-marker', `${index}`);

      if (index === 0) {
        createElement.classList.add(`active`);
      }
      createElement.innerText = el.innerText;

      tableBlock.appendChild(createElement);

      coordsArr.push(el.getBoundingClientRect().top + staticPositionOfWindow);

      createElement.addEventListener('click', function (event) {
        window.scrollTo({
          top: coordsArr[+event.target.dataset.marker] - distanceToScroll,
          behavior: 'smooth',
        });
      });
    });

    sidebar.appendChild(tableBlock);

    const shareContent = document.querySelector('#share-content');

    if (shareContent) {
      const shareWrapper = document.createElement('div');
      shareWrapper.classList.add('sidebar__share', 'share');

      const originalParent = shareContent.parentNode;
      const mq = window.matchMedia('(min-width: 1201px)');

      const toggleShare = () => {
        if (mq.matches) {
          shareWrapper.appendChild(shareContent);
          sidebar.appendChild(shareWrapper);
        } else {
          originalParent.appendChild(shareContent);
          shareWrapper.remove();
        }
      };

      toggleShare();
      mq.addEventListener('change', toggleShare);
    }

    row.appendChild(sidebar);

    window.addEventListener('load', markItem);
    window.addEventListener('scroll', markItem);

    function markItem() {
      let dinamicPosition = window.pageYOffset;
      coordsArr.forEach((element, index) => {
        if (dinamicPosition >= 0 && dinamicPosition < coordsArr[0]) {
          document.querySelector('.active')?.classList.remove('active');
          tableBlock.children[0].classList.add('active');
        }

        if (
          (element > dinamicPosition && element < dinamicPosition + visibleArea) ||
          (element >= staticPositionOfWindow &&
            element <= staticPositionOfWindow + visibleArea &&
            element <= staticPositionOfWindow)
        ) {
          document.querySelector('.active')?.classList.remove('active');
          tableBlock.children[index].classList.add('active');
        }
      });
    }
  }
}
